var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-body"},[_c('div',{staticClass:"text"},[_c('span',{staticClass:"oops"},[_vm._v("Încă lucrăm!")]),_c('img',{attrs:{"src":require("@/assets/images/construction-background.jpg")}})]),_c('div',{staticClass:"info-text"},[_c('span',[_vm._v("ACEASTĂ PAGINĂ ESTE ÎNCĂ ÎN CONSTRUCȚIE")]),_c('p',[_vm._v("Vă mulțumim pentru întelegere.")]),_c('br')])])
}]

export { render, staticRenderFns }